/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
  OnInit,
  signal,
  Inject,
  HostBinding
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';

import { EnvironmentService } from '@environment';
import { TRACKING_SERVICE, TrackingAction, TrackingService } from '@usheru-hff/sdk/tracking';
import { getMovieGenres, getMovieTags, Movie } from '@usheru-hff/shared/domain';
import { Caption } from '@usheru-hff/shared/ui-video';
import { TranslationsService } from '@usheru-hff/shared/utils-translation';
import { Player, PlayerPrice, UplayerService } from '@usheru-hff/uplayer/domain';
import { UplayPlayButtonComponent } from '@usheru-hff/uplayer/feature-my-films-page';

import { UserFilmItem } from 'libs/uplayer/feature-my-films-page/src/lib/models/user-film-item.model';

/**

 * Component to that will be displayed if the movie has uPlayer available. Used to redirect

 * to buy uPlayer or to play the streaming it.

 *

 * //TODO barbeitoalex propostal - organice life cycle methods. Split in specific method to improve docs.

 * //TODO barbeitoalex propostal - move component folder to the root of components

 * //TODO barbeitoalex propostal - update translate text with an observable to the current language

 * //TODO barbeitoalex propostal - subscribe to current language to update the translate pipes

 *

 */

@Component({
  selector: 'ush-uplay-button',
  standalone: true,
  imports: [CommonModule, RouterLink, FontAwesomeModule, UplayPlayButtonComponent],
  templateUrl: './uplay-button.component.html',
  styleUrls: ['./uplay-button.component.scss']
})
export class UplayButtonComponent implements OnChanges, OnInit {
  @HostBinding('attr.data-player-prices-length') dataPlayerPricesLength = 0;

  /**

   * @docNotNeccesary

   *

   * //TODO barbeitoalex propostal - execute {@link loadPlayerPrices} in the setter

   */

  @Input() movie: Movie;

  /**

   * Emit in process {@link loadPlayerPrices} and {@link updateMinValues}.

   */

  @Output() uplayLoaded = new EventEmitter();

  //

  /**

   * Variables used for knowing if we display the "watch now" or "play now" texts

   */

  availableToWatchOn?: string;

  /**

   * Status to know if is purchased by the logged user.

   */

  purchased: boolean;

  /**

   * Status to know if the {@link loadPlayerPrices} has done.

   */

  loaded = false;

  /**

   * @deprecated Don't found any use

   */

  videoUrl: string;

  /**

   * @deprecated Don't found any use

   */

  videoCaptions: Caption;

  /**

   * {@link playerPrices} option bought it by the user.

   */

  player: Player;

  /**

   * Value string of {@link minPlayerPrice}.

   */

  price: string;

  /**

   * Most cheapest {@link playerPrices} option.

   */

  minPlayerPrice: PlayerPrice;

  /**

   * @docNotNeccesary

   */

  faPlay = faPlay;

  /**

   * Loaded by {@link loadPlayerPrices}.

   */

  playerPrices: PlayerPrice[] = [];

  /**

   * @docNotNeccesary

   */

  @Input() watchNowCustomString?: string;

  /**

   * @docNotNeccesary

   */

  @Input() playNowCustomString?: string;

  /**

   * @docNotNeccesary

   */

  @Input() preOrderCustomString?: string;

  /**

   * @docNotNeccesary

   */

  @Input() availableToWatchCustomString?: string;

  /**

   * @deprecated Don't found any use

   */

  isItAvailableToWatch?: boolean;

  /**

   * Used to play it the player from a external input.

   *

   * //TODO barbeitoalex propostal - subscribe in the setter.

   */

  @Input()
  triggerPlay: BehaviorSubject<boolean>;

  /**

   * Status to know if is purchased by the logged user.

   *

   * //TODO barbeitoalex propostal - could be merged {@link purchased} and refractor to that name

   */

  // eslint-disable-next-line @angular-eslint/no-output-rename

  @Output('purchased')
  outputPurchased = new BehaviorSubject<boolean>(false);

  uplayMessage: string;
  uplayMessageKey = 'movie.availableToWatch';

  hidePriceOnWatchNowButton: boolean;

  userPlayItem = signal<UserFilmItem | null>(null);

  readonly MOVIE_PREORDER_TEXT = $localize`:@@movie.preorder:Pre-order`;
  readonly MOVIE_WATCHNOW_TEXT = $localize`:@@movie.watchNow:Watch Now`;
  readonly MOVIE_AVAILABLE_TO_WATCH_TEXT = $localize`:@@movie.availableToWatch:Available to watch on`;

  constructor(
    private uplayerService: UplayerService,

    private translateService: TranslationsService,
    @Inject(TRACKING_SERVICE) private trackingService: TrackingService,
    private cd: ChangeDetectorRef,

    private environmentService: EnvironmentService
  ) {
    this.hidePriceOnWatchNowButton = this.environmentService.uplayerComponent('hidePriceOnWatchNowButton');
  }

  ngOnInit(): void {
    this.loadPlayerPrices();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.movieWasChanged(changes['movie']?.currentValue, changes['movie']?.previousValue)) {
      this.loaded = false;
    }

    // Trigger only one time when the the value is set

    if (changes['triggerPlay']?.previousValue === undefined && changes['triggerPlay']?.currentValue) {
      this.triggerPlay.pipe(filter(val => val)).subscribe(() => {
        this.playVideo();
      });
    }
  }

  private movieWasChanged(currentMovie: Movie, previousMovie: Movie): boolean {
    return (
      currentMovie?.friendlyUrl !== previousMovie?.friendlyUrl || currentMovie?.hasPlayer !== previousMovie?.hasPlayer
    );
  }

  /**

   * Used in a routerLink state for preorders.

   *

   * //TODO barbeitoalex propostal - refractor name to be more descriptive.

   * @returns

   */

  // eslint-disable-next-line @typescript-eslint/no-explicit-any

  getData(): any {
    return {
      data: {
        movie: this.movie
      }
    };
  }

  /**
   * Used in a routerLink for preorders and watchnow.
   *
   * //TODO barbeitoalex propostal - refractor name to be more descriptive.
   * @returns
   */
  getRoute(): string {
    return `/uplayer-purchase/${this.movie.friendlyUrl}`;
  }

  /**

   * Used to load player prices to know if display the button.

   *

   * //TODO barbeitoalex propostal - the {@link availableToWatchOn} will be overwritte by {@link updateMinValues}

   * //TODO barbeitoalex propostal - add here the availableToWatchOn, loaded and uplayLoaded.emit from {@link updateMinValues}

   */

  loadPlayerPrices() {
    this.outputPurchased.next(false);

    this.uplayerService.$playerPrices.subscribe(playerPrices => {
      if (playerPrices?.length > 0) {
        this.dataPlayerPricesLength = playerPrices.length;
        this.player = this.uplayerService.getPurchasedPlayer(playerPrices);

        if (this.player) {
          this.purchased = true;

          this.availableToWatchOn = this.getAvailableToWatchDate(playerPrices.find(pp => pp.purchaseDate != undefined));

          this.outputPurchased.next(this.player.url ? true : false);

          this.videoUrl = this.uplayerService.getPlayerUrl();

          this.uplayLoaded.emit(true);

          this.loaded = true;

          this.cd.detectChanges();

          return;
        } else {
          this.purchased = false;

          this.loaded = true;
        }

        this.playerPrices = playerPrices;

        this.minPlayerPrice = this.uplayerService.getMinPrice(playerPrices);

        this.updateMinValues();

        this.cd.detectChanges();
      } else {
        this.playerPrices = [];
        this.dataPlayerPricesLength = 0;
        this.loaded = true;
      }
    });
  }

  /**

   * Set the {@link price} with the correct currency.

   *

   * //TODO barbeitoalex propostal - remove the availableToWatchOn, loaded and uplayLoaded.emit

   * //TODO barbeitoalex propostal - refractor name to "updatePriceMinValue"

   */

  updateMinValues() {
    this.price = `${this.minPlayerPrice.currencyBadge || '€'}${this.minPlayerPrice.priceInCents / 100}`;

    this.availableToWatchOn = this.getAvailableToWatchDate(this.minPlayerPrice);

    this.uplayMessage = $localize`:@@movie.availableToWatch:Available to watch on ${this.availableToWatchOn}`;

    this.loaded = true;

    this.uplayLoaded.emit(true);
  }

  /**

   * Check if a player-price will be available it will be available and returns this date.

   * @param pp

   * @returns

   */

  getAvailableToWatchDate(pp: PlayerPrice) {
    return pp.availableOnFuture ? this.getFriendlyDate(pp.availableFrom) : '';
  }

  /**

   * Formated date string to "weekday DD-month"

   * @param date

   * @returns

   */

  getFriendlyDate(date) {
    return new Date(date).toLocaleDateString(this.translateService.currentLanguage().code, {
      weekday: 'short',

      day: '2-digit',

      month: 'short'
    });
  }

  /**

   * @docNotNeccesary

   */

  playVideo() {
    this.uplayerService.playVideo(this.player);
  }

  /**

   * Event to watchnow button.

   */

  watchNowSelected(): void {
    this.trackEvent('AddToCart', this.movie.title);
  }

  preOrderSelected(): void {
    this.trackEvent('AddToCart', this.movie.title);
  }

  /**
   * Used to display the UplayPlayButtonComponent
   */
  generateUserFilmItem(availableTo: string | number): void {
    this.userPlayItem.set({
      movie: this.movie,
      player: this.player,
      availableTo: availableTo
    });
  }

  trackEvent(action: TrackingAction, label: string): void {
    this.trackingService.trackEvent({
      action,

      properties: {
        category: 'uPlay',

        label,

        movie: this.movie.title,

        idMovie: this.movie.id,

        imdb: this.movie?.imdb,

        tagsMovie: getMovieTags(this.movie),

        genresMovie: getMovieGenres(this.movie),

        idPlayer: this.player?.id
      }
    });
  }

  get moviePreorderText(): string {
    return this.preOrderCustomString || this.MOVIE_PREORDER_TEXT;
  }

  get movieWatchNowText(): string {
    return this.watchNowCustomString || this.MOVIE_WATCHNOW_TEXT;
  }

  get movieAvailableToWatchText(): string {
    return this.availableToWatchCustomString || this.MOVIE_AVAILABLE_TO_WATCH_TEXT;
  }
}
